//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DefaultNoResultsAsset from "@Shared/@Assets/img/user-male-placeholder.png";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "NoResults",
  props: {
    icon: {
      type: String,
      default: ""
    },
    imgSrc: {
      type: [Object, String],
      default: () => DefaultNoResultsAsset
    },
    imgClass: {
      type: String,
      default: "img-fluid rounded-circle lg"
    },
    iconClass: {
      type: String,
      default: "text-gray"
    },
    textClass: {
      type: String,
      default: "text-gray mt-2"
    },
    textStyle: {
      type: String,
      default: "font-size: 1.2em;"
    }
  }
});